export default "__VITE_ASSET__mqgOOBCt__"